import React, { useState } from 'react';
import './DrinkSelectPage.css';

export default function DrinkSelectPage({ item, cart, onAddToCart, onUpdateQuantity, onBack }) {
  const options = item.drink_options ? item.drink_options.split('|') : [];

  const drinkCartKeys = options.flatMap(opt =>
    opt === '紅茶' ? [`${item.id}_紅茶冰`, `${item.id}_紅茶熱`] : [`${item.id}_${opt}`]
  );
  const existingItems = cart.filter(c => drinkCartKeys.includes(c.cartKey));

  const [selectedDrink, setSelectedDrink] = useState(null);
  const [selectedTemp, setSelectedTemp] = useState('冰');

  const handleAdd = () => {
    if (!selectedDrink) return;
    const cartKey = selectedDrink === '紅茶'
      ? `${item.id}_紅茶${selectedTemp}`
      : `${item.id}_${selectedDrink}`;
    const displayName = selectedDrink === '紅茶'
      ? `${item.name} (紅茶${selectedTemp})`
      : `${item.name} (${selectedDrink})`;
    onAddToCart({
      id: item.id,
      cartKey,
      displayName,
      price: item.price,
      size: selectedDrink === '紅茶' ? `紅茶${selectedTemp}` : selectedDrink,
    });
    setSelectedDrink(null);
  };

  const drinkLabel = key => key.replace(`${item.id}_`, '');

  return (
    <div className="drink-page">
      <div className="drink-page-header">
        <button className="drink-page-back" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          返回菜單
        </button>
      </div>

      <div className="drink-page-body">
        <div className="drink-page-item-name">{item.name}</div>
        {item.description && (
          <div className="drink-page-item-desc">{item.description}</div>
        )}

        {existingItems.length > 0 && (
          <div className="drink-existing-section">
            <div className="drink-page-section-label">已選飲品</div>
            <div className="drink-existing-list">
              {existingItems.map(ci => (
                <div key={ci.cartKey} className="drink-existing-row">
                  <span className="drink-existing-label">{drinkLabel(ci.cartKey)}</span>
                  <div className="qty-ctrl">
                    <button onClick={() => onUpdateQuantity(ci.cartKey, -1)}>−</button>
                    <span>{ci.quantity}</span>
                    <button onClick={() => onUpdateQuantity(ci.cartKey, 1)}>+</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="drink-page-section-label">
          {existingItems.length > 0 ? '再加一份' : '選擇飲品'}
        </div>
        <div className="drink-page-options">
          {options.map(opt => (
            <button
              key={opt}
              className={`drink-page-choice-btn${selectedDrink === opt ? ' selected' : ''}`}
              onClick={() => setSelectedDrink(opt)}
            >
              {opt}
            </button>
          ))}
        </div>

        {selectedDrink === '紅茶' && (
          <>
            <div className="drink-page-section-label">選擇溫度</div>
            <div className="drink-page-temp-row">
              <button
                className={`drink-page-temp-btn temp-ice${selectedTemp === '冰' ? ' selected' : ''}`}
                onClick={() => setSelectedTemp('冰')}
              >冰</button>
              <button
                className={`drink-page-temp-btn temp-hot${selectedTemp === '熱' ? ' selected' : ''}`}
                onClick={() => setSelectedTemp('熱')}
              >熱</button>
            </div>
          </>
        )}

        <button
          className={`drink-page-add-btn${selectedDrink ? '' : ' disabled'}`}
          onClick={handleAdd}
          disabled={!selectedDrink}
        >
          加入
        </button>
      </div>

      <div className="drink-page-footer">
        <button className="drink-page-confirm-btn" onClick={onBack}>
          完成
        </button>
      </div>
    </div>
  );
}
